"use client";

import type { ReactNode } from "react";

import { AuthProvider } from "@/contexts/auth-context";
import { RoleProvider } from "@/contexts/role-context";
import { AuthGuard } from "@/components/auth-guard";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <RoleProvider>
        <AuthGuard>{children}</AuthGuard>
      </RoleProvider>
    </AuthProvider>
  );
}
